import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Input,
  OnDestroy,
  OnInit,
} from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { EventsStore } from '@store';
import { ViEvent } from '@vi-iot/client/index';

@Component({
  selector: 'app-event-list',
  templateUrl: './event-list.component.html',
  styleUrls: ['./event-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EventListComponent implements OnInit, OnDestroy {
  ngUnsubscribe = new Subject<void>();
  fetchMore$ = new Subject<void>();

  // used for internal calculations of infinite scroll
  buffer = [];

  scrollItems: ViEvent[] = [];
  loading: boolean;
  filterTypes: string[];

  @Input()
  installationId: number;
  @Input()
  gatewaySerial: string;
  @Input()
  panelContentHeight: number;

  constructor(public eventsStore: EventsStore, private cdr: ChangeDetectorRef) {}

  ngOnInit(): void {
    this.eventsStore.events$.pipe(takeUntil(this.ngUnsubscribe)).subscribe((events) => {
      this.buffer = events;
      this.cdr.markForCheck();
    });

    this.loadData();
  }

  loadData(): void {
    this.eventsStore.loadEvents();
  }

  ngOnDestroy(): void {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }
}
